// eslint-disable-next-line no-restricted-imports
import dayjs, { type Dayjs as DayjsOriginalType } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import "dayjs/locale/en-ca";
import "dayjs/locale/es";
import "dayjs/locale/fr-ca";
import "dayjs/locale/ja";

/**
 * dependencies antd --> uses rc-picker --> uses dayjs
 * Inside rc-picker the dayjs global is manipulated to extend the following plugins.
 * When we install dayjs if the versions are different we might get our own dayjs dependency instance
 * Passing this type of dayjs object might crash the app without mirroring those replications
 * Eg: https://github.com/react-component/picker/blob/master/src/generate/dayjs.ts#L2-L16
 *
 * For now the dependency is mirrored and made concrete
 */
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);

export { dayjs };
export type Dayjs = DayjsOriginalType;
